
export const selectRowByUid = (dataArray, checked, id) => {
  const updatedDataArray = [...dataArray];
  const index = updatedDataArray.findIndex((row) => row.uid === id);

  if (index > -1) {
    updatedDataArray[index].rowConfig.selected = checked;
  }

  return updatedDataArray;
};

export const selectAllRows = (tableData, checked) => {
  return tableData.map((row) => ({
    ...row,
    rowConfig: {
      ...row.rowConfig,
      selected: checked,
    },
  }));
};


export const selectionState = (dataArray) => {
  const total = dataArray.length;
  const selected = dataArray.filter((row) => row.rowConfig.selected).length;

  switch (selected) {
    case 0:
      return "none";
    case total:
      return "all";
    default:
      return "indeterminated";
  }
};

export const selectRow = (dataArray, checked, id) => {
  const updatedDataArray = [...dataArray];
  const index = updatedDataArray.findIndex((row) => row.uid === id);

  if (index > -1) {
    updatedDataArray[index].rowConfig.selected = checked;
  }

  return updatedDataArray;
};

export const selectAllPageItems = (tableData, checked) => {
  return tableData.map((row) => {
    const newRow = { ...row };
    newRow.rowConfig = { ...newRow.rowConfig, selected: checked };
    return newRow;
  });
};

export const getSelectedPresses = (pressListBySeriesFilter) => {
  return pressListBySeriesFilter.filter((press) => press.rowConfig.selected === true);
};

export const hasMixed6kPlusSelection = (selectedPresses) => {
  const classifications = selectedPresses.map((x) => x.classification);

  return (
    classifications.some((x) => x.toLowerCase() === "6k+") &&
    classifications.some((x) => x.toLowerCase() !== "6k+")
  );
};